import axios from 'axios'
import React, {useEffect, useState} from 'react'
import {useSelector} from 'react-redux'
import {useHistory} from 'react-router-dom'
import dayjs from 'dayjs';
import { RootState } from '../../../../../setup';
import { QueryData } from '../../../../reusable-components/tables/DynamicTableTypes';
import { toast } from 'react-toastify';
import TableTitle from '../../../../reusable-components/tables/TableTitle';
import TableWrapper from '../../../../reusable-components/tables/TableWrapper';
import { permissions } from '../../../../../_constants/permissions';
import TableSearchBar from '../../../../reusable-components/tables/TableSearchBar';
import { hasPermission } from '../../../../../_helper/hasPermission';
import TableButton from '../../../../reusable-components/tables/TableButton';
import DynamicTable from '../../../../reusable-components/tables/DynamicTable';
import { ASSESSMENT_COLUMNS, ASSESSMENT_COLUMNS_DATA_MAPPING, ASSESSMENT_SORTING_COLUMNS } from '../GENERAL_TABLE_CONSTANTS';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined'
import NoteEntryModal from '../../../../reusable-components/Modals/NoteEntryModal'

const selectAuth = (state: RootState) => state.auth;
const selectTimeZone = (state: RootState) => state.timeZone.timeZone

export default function NursesAsessmentList() {
  const authUser = useSelector((state: {auth: any}) => state.auth)
  const history = useHistory()
  const [filteredData, setFilteredData] = useState([])
  const [noteEntryData, setNoteEntryData] = useState<any>({});
  const [isFetchingData, setIsFetchingData] = useState(true);
  const timeZone = useSelector(selectTimeZone)
  const [searchTerm, setSearchTerm] = useState('')
  const [hasExpiredDocuments, setHasExpiredDocuments] = useState(false)
  const [queryData, setQueryData] = useState<QueryData>({
      pageNumber: 1,
      pageSize: 5,
      currentPage: 1,
      totalCounts: 1,
      sortBy: '_id',
      sortDir: 'desc',
      searchTerm: '',
  })
  const auth = useSelector(selectAuth);
  const userPermissions = auth.user.roleId;
  const [loadingStates, setLoadingStates] = useState({});
  const [logoUrl, setLogoUrl] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const companyLogo = auth?.user?.companyLogo;
  const isDocumentExpired = auth?.user?.isDocumentExpired;
  const [isNoteEntryModalOpen, setIsNoteEntryModalOpen] = useState(false);
  const [deletedID, setDeletedID] = useState<string | null>(null)
  useEffect(() => {
    const fetchData = async (page: number, pageSize: number, sortBy: string, sortDir: string, search: string) => {
      setIsFetchingData(true);
      try {
        const response = await axios.get(`/nursesAssessment/getAll`, {
          params: {
            page,
            pageSize,
            sortBy,
            sortOrder: sortDir,
            searchTerm: search,
          },
        });
        const { data, currentPage, totalCounts } = response.data;
        const updatedData = data.map((item) => ({
          ...item,
        }));
        setFilteredData(updatedData);
        setQueryData((prevState) => ({
          ...prevState,
          currentPage,
          totalCounts,
        }));

      } catch (error) {
        if (axios.isCancel(error)) {
          console.log('Request canceled', error.message);
        } else {
          console.log('Error: ', error.message);
        }
      } finally {
        setIsFetchingData(false);
      }
    };

    fetchData(queryData.pageNumber, queryData.pageSize, queryData.sortBy, queryData.sortDir, queryData.searchTerm);
  }, [queryData.pageNumber, queryData.pageSize, queryData.sortBy, queryData.sortDir, queryData.searchTerm, deletedID]);

  const fetchPresignedUrl = async (key: string) => {
  try {
    if (key?.startsWith("http")) {
      console.log("Already a URL, skipping presigned URL fetch.");
      setLogoUrl(key); 
      return;
    }

    const response = await axios.get(`/batchfile/fetch-file-url`, {
      params: { fileKey: key },
    });

    if (response.status === 200) {
      setLogoUrl(response.data.presignedUrl);
    }
  } catch (error) {
    console.error("Error fetching company logo URL:", error);
    setErrorMessage("Failed to fetch company logo.");
  }
};

useEffect(() => {
  if (companyLogo) {
    fetchPresignedUrl(companyLogo);
  }
}, [companyLogo]);

  const handleRedirectToNewPage = (data: any) => {
    if (data.clientId && data.noteType) {
      history.push({
        pathname: `/notes/nurses-notes/entry/new`,
        state: { clientId: data.clientId, noteType: data.noteType },
    })
  }
}

const setLoading = (id: string, action: string, isLoading: boolean) => {
  setLoadingStates((prev) => ({
    ...prev,
    [id]: {
      ...prev[id],
      [action]: isLoading,
    },
  }));
};
  const onClickAddButton = () => {
    history.push('/notes/nurses-notes/new')
  }
  
  const onUpdate = (row) => {
    history.push(`/notes/nurses-notes/edit/${row['_id']}`)
  }
  
  const onView = (row) => {
    history.push(`/notes/nurses-notes/entry/${row.clientId}?noteType=${row.noteType}&nursesAssessmentId=${row._id}`)
  }

  const handleDeletedAssessments = () => {
    history.push(`/deleted-notes/nurses-notes/list`)
  }
  

  const handleNoteEntryModalClose = () => {
    setIsNoteEntryModalOpen(false)
  }
  const onDownload = async (row: any) => {
  try {
    setLoading(row._id, 'download', true);
    
    let finalCompanyLogoUrl = '';
    if (companyLogo?.startsWith('http')) {
      finalCompanyLogoUrl = companyLogo;
    } else {
      finalCompanyLogoUrl = logoUrl;
    }

    let assessmentData = row;
    if (!row.generalInformation) {
      const response = await axios.get(`/nursesAssessment/getById/${row._id}`);
      assessmentData = response.data.data;
    }

    const formData = {
      ...assessmentData,
      userId: auth.user._id,
      companyLogoUrl: finalCompanyLogoUrl,
      generalInformation: {
        ...assessmentData.generalInformation,
        assessmentDate: assessmentData.generalInformation?.assessmentDate 
          ? dayjs.utc(assessmentData.generalInformation.assessmentDate)
              .tz(timeZone, true).format('MM-DD-YYYY')
          : 'No date provided',
      },
      medicalDetails: {
        ...assessmentData.medicalDetails,
        lastFluVaccine: assessmentData.medicalDetails?.lastFluVaccine
          ? dayjs.utc(assessmentData.medicalDetails.lastFluVaccine)
              .tz(timeZone, true).format('MM-DD-YYYY')
          : null,
        lastPneumoniaVaccine: assessmentData.medicalDetails?.lastPneumoniaVaccine
          ? dayjs.utc(assessmentData.medicalDetails.lastPneumoniaVaccine)
              .tz(timeZone, true).format('MM-DD-YYYY')
          : null,
      },
      gastroIntestinal: {
        ...assessmentData.gastroIntestinal,
        lastBMdate: assessmentData.gastroIntestinal?.lastBMdate
          ? dayjs.utc(assessmentData.gastroIntestinal.lastBMdate)
              .tz(timeZone, true).format('MM-DD-YYYY')
        : null,
      },
      genitourinary: {
        ...assessmentData.genitourinary,
        catheterDate: assessmentData.genitourinary?.catheterDate
          ? dayjs.utc(assessmentData.genitourinary.catheterDate)
              .tz(timeZone, true).format('MM-DD-YYYY')
          : null,
      },
    };

    const response = await axios.post('/nursesAssessment/generateAssessmentPDF', formData, {
      responseType: 'blob',
    });

    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    const clientName = assessmentData.client 
    ? `${assessmentData.client.firstName || ''} ${assessmentData.client.lastName || ''}`.trim()
    : 'Unknown_Client'; 
    link.setAttribute('download', 
      `${assessmentData.noteType}_Nurses_Assessment_for_${clientName}.pdf`
    );
    document.body.appendChild(link);
    link.click();
    
    window.URL.revokeObjectURL(url);
    document.body.removeChild(link);
    
    setLoading(row._id, 'download', false);
  } catch (err) {
    console.error('Error while downloading assessment:', err);
    toast.error('Failed to download assessment PDF');
    setLoading(row._id, 'download', false);
  }
};

const onDelete = async (row: any) => {
  try {
    const response = await axios.delete(`/nursesAssessment/delete/${row._id}`)
    if (response.status === 200) {
      toast.success('Nursing Assessment deleted successfully')
      setDeletedID(row._id)
    }
  } catch (err) {
    toast.error('Failed to delete Nursing Assessment')
  }
}
  return (
    <div className='card'>
      <div className='card-body'>
        <TableTitle title='Nursing Assessment'></TableTitle>
        <TableWrapper 
          searchField={
            hasPermission(userPermissions, permissions.care_giver_notes_note_search) &&
            <TableSearchBar
              label='Search'
              variant='outlined'
              size='small'
              value={searchTerm}
              setQueryData={setQueryData}
              setSearchTerm={setSearchTerm}
              margin='normal'
              inputAdornmentPosition='start'
            ></TableSearchBar>
          }
          tableButtons={
            <>
            <div className='d-flex justify-content-end flex-wrap-reverse gap-3'>
            <TableButton
                variant={'contained'}
                color={'primary'}
                title='Deleted Assessments'
                onClick={handleDeletedAssessments}
              />
                {hasPermission(userPermissions, permissions.notes_nurses_note_create) && !hasExpiredDocuments &&
                <TableButton
                  variant={'contained'}
                  color={'primary'}
                  title='Add Assessment'
                  onClick={onClickAddButton}
                />
              }
              {hasPermission(userPermissions, permissions.notes_nurses_note_create) && 
              !hasExpiredDocuments &&
                <TableButton
                  variant={'contained'}
                  color={'primary'}
                  title='Add Note Entry'
                  onClick={() => setIsNoteEntryModalOpen(true)}
                />
              }
              
            </div>
            </>
            
          }
          dynamicTable={
            <>
            <span className='ml-2 text-primary d-flex align-items-center gap-2'>For view Nurses notes please click on <VisibilityOutlinedIcon /> icon in the table</span>
           <DynamicTable
            htmlColumns={[]}
            columns={ASSESSMENT_COLUMNS}
            data={filteredData}
            canDownload={true}
            canDelete={hasPermission(userPermissions, permissions.notes_nurses_note_delete) && !hasExpiredDocuments}
            onDelete={onDelete}
            canUpdate={
              hasPermission(userPermissions, permissions.notes_nurses_note_update) && 
              !hasExpiredDocuments
            }
            onUpdate={onUpdate}
            onDownload={onDownload}
            loadingStates={loadingStates}
            sortingColumns={ASSESSMENT_SORTING_COLUMNS}
            canView={
              hasPermission(userPermissions, permissions.notes_nurses_note_view) && 
              !hasExpiredDocuments
            }
            onView={onView}
            setQueryData={setQueryData}
            queryData={queryData}
            columnDataMapping={ASSESSMENT_COLUMNS_DATA_MAPPING}
            tableLoader={isFetchingData}
            title='Are you sure you want to delete this Nursing Assessment?'
          />
            </>
            
          }
        />
        
        {/* Note Entry Modal */}
        <NoteEntryModal
          open={isNoteEntryModalOpen}
          onClose={handleNoteEntryModalClose}
          noteCheckingRoute="/nursesAssessment/checkExisting"
          redirectToNewPage={handleRedirectToNewPage}
        />
      </div>
    </div>
  )
}